// This file is auto-generated by @hey-api/openapi-ts

import type { Options as ClientOptions, TDataShape, Client } from '@hey-api/client-fetch';
import type { AppHealthCheckData, AppHealthCheckResponse, AppMetricsData, AppMetricsResponse, AuthLoginData, AuthLoginResponse, AuthAdminLoginData, AuthAdminLoginResponse, AuthRegisterData, AuthRegisterResponse, AuthRefreshTokensData, AuthRefreshTokensResponse, AuthMeData, AuthMeResponse, AuthLogoutData, AuthForgotPasswordData, AuthResetPasswordData, AuthImpersonateData, UserFindMeData, UserFindMeResponse, UserOnboardingData, UserSignContractData, UserSignContractResponse, UserSuspendContractData, UserSuspendContractResponse, UserGetAwayRangesData, UserGetAwayRangesResponse, UserCreateAwayRangeData, UserCreateAwayRangeResponse, UserDeleteAwayRangeData, UserDeleteAwayRangeResponse, UserGetAwayRangeForUserData, UserGetAwayRangeForUserResponse, UserUpdateAwayRangeData, UserUpdateAwayRangeResponse, UserUpdateData, UserUpdateResponse, UserMyLocationData, UserMyLocationResponse, UserRemoveFriendData, UserRequestFriendData, UserAcceptFriendRequestData, UserDeclineFriendRequestData, UserListReceivedRequestsData, UserListReceivedRequestsResponse, UserListSentRequestsData, UserListSentRequestsResponse, UserMyFriendRelationshipData, UserMyFriendRelationshipResponse, UserPrefillData, UserPrefillResponse, UserListFriendsData, UserListFriendsResponse, UserListMessageableUsersData, UserListMessageableUsersResponse, UserCountReferredData, UserCountReferredResponse, UserListData, UserListResponse, UserListPublicData, UserListPublicResponse, UserMembersData, UserMembersResponse, UserMembersPublicData, UserMembersPublicResponse, UserMembersWithFriendsData, UserMembersWithFriendsResponse, UserMyProfileData, UserMyProfileResponse, UserCountData, UserCountResponse, UserFindOneData, UserFindOneResponse, UserVerifyEmailData, UserVerifyEmailResponse, UserGetCommunitiesData, UserGetCommunitiesResponse, UserCreateCommunityData, UserCreateCommunityResponse, UserDeleteCommunityData, UserUpdateCommunityData, UserUpdateCommunityResponse, UserAddMemberToCommunityData, UserAddMemberToCommunityResponse, UserRemoveMemberFromCommunityData, UserRemoveMemberFromCommunityResponse, UserAddLeaderToCommunityData, UserAddLeaderToCommunityResponse, UserRemoveLeaderFromCommunityData, UserRemoveLeaderFromCommunityResponse, UserCreateTagData, UserCreateTagResponse, UserGetTagsData, UserGetTagsResponse, UserAddUserToTagData, UserAddUserToTagResponse, UserRemoveUserFromTagData, UserRemoveUserFromTagResponse, UserUpdateTagData, UserUpdateTagResponse, UserDeleteTagData, UserReferrerProfileData, UserReferrerProfileResponse, UserOnetimeInviteData, UserOnetimeInviteResponse, UserRequestOnetimeInviteData, UserRequestOnetimeInviteResponse, UserApproveOnetimeInviteData, UserApproveOnetimeInviteResponse, UserRejectOnetimeInviteData, UserCreateOnetimeInviteData, UserCreateOnetimeInviteResponse, UserCreateCommunityInviteData, UserCreateCommunityInviteResponse, UserGetCommunityInvitesData, UserGetCommunityInvitesResponse, UserDeleteOnetimeInviteData, UserDeleteCommunityInviteData, UserGetCommunityInvitesForUserData, UserGetCommunityInvitesForUserResponse, UserGetOnetimeInvitesData, UserGetOnetimeInvitesResponse, UserGetOnetimeInvitesByCommunityData, UserGetOnetimeInvitesByCommunityResponse, UserGetOnetimeInvitesByRequesterData, UserGetOnetimeInvitesByRequesterResponse, UserGetMyCommunitiesData, UserGetMyCommunitiesResponse, UserGetCommunityMemberContactInfoData, UserGetCommunityMemberContactInfoResponse, UserGetCommunityMemberContactInfoAdminData, UserGetCommunityMemberContactInfoAdminResponse, UserGetAllMemberContactInfoData, UserGetAllMemberContactInfoResponse, UserAcceptCommunityInviteData, UserRejectCommunityInviteData, UserLeaveCommunityData, UserRegisterDeviceData, UserRegisterDeviceResponse, UserSendPushNotificationData, UserSendPushNotificationResponse, ImagesGetImageData, ImagesGetImageResponse, ImagesDeleteImageData, ImagesUploadImageData, ImagesUploadImageResponse, MailgunWebhookHandleData, ConversationGetAllConversationsForAdminData, ConversationGetAllConversationsForAdminResponse, ConversationGetMyConversationsData, ConversationGetMyConversationsResponse, ConversationGetCommunityConversationsData, ConversationGetCommunityConversationsResponse, ConversationCreateDirectConversationData, ConversationCreateDirectConversationResponse, ConversationCreateGroupConversationData, ConversationCreateGroupConversationResponse, ConversationUpdateInfoData, ConversationUpdateInfoResponse, ConversationAcceptInviteData, ConversationAcceptInviteResponse, ConversationDeclineInviteData, ConversationDeclineInviteResponse, ConversationAddParticipantData, ConversationAddParticipantResponse, ConversationRemoveParticipantData, ConversationRemoveParticipantResponse, ConversationMarkReadData, ConversationMarkReadResponse, ConversationGetUnreadMessagesData, ConversationGetUnreadMessagesResponse, ConversationLeaveData, ConversationLeaveResponse, MessageGetConversationMessagesForAdminData, MessageGetConversationMessagesForAdminResponse, MessageSendMessageData, MessageSendMessageResponse, MessageGetMessagesData, MessageGetMessagesResponse, ActionsJoinData, ActionsJoinResponse, ActionsDeclineData, ActionsDeclineResponse, ActionsOptoutData, ActionsOptoutResponse, ActionsCompleteData, ActionsCompleteResponse, ActionsMyStatusData, ActionsMyStatusResponse, ActionsFindAllData, ActionsFindAllResponse, ActionsFindAllLoggedInData, ActionsFindAllLoggedInResponse, ActionsMyActivityData, ActionsMyActivityResponse, ActionsUserLocationsData, ActionsUserLocationsResponse, ActionsGetActivityFeedData, ActionsGetActivityFeedResponse, ActionsGetActivityData, ActionsGetActivityResponse, ActionsGetEventData, ActionsGetEventResponse, ActionsGetNotificationScheduleData, ActionsGetNotificationScheduleResponse, ActionsGetActionActivitiesData, ActionsGetActionActivitiesResponse, ActionsFindAllWithDraftsData, ActionsFindAllWithDraftsResponse, ActionsSseActionCountData, ActionsLiveListData, ActionsFriendActivityForActionData, ActionsFriendActivityForActionResponse, ActionsFriendActivityData, ActionsFriendActivityResponse, ActionsCommunityActivityData, ActionsCommunityActivityResponse, ActionsFindOneData, ActionsFindOneResponse, ActionsFindOneAdminData, ActionsFindOneAdminResponse, ActionsCreateData, ActionsCreateResponse, ActionsRemoveData, ActionsUpdateData, ActionsUpdateResponse, ActionsFindCompletedForUserData, ActionsFindCompletedForUserResponse, ActionsAddEventData, ActionsAddEventResponse, ActionsUpdateReminderGroupData, ActionsUpdateReminderGroupResponse, ActionsCreateReminderGroupData, ActionsCreateReminderGroupResponse, ActionsDeleteReminderGroupData, ActionsPlansForGroupData, ActionsPlansForGroupResponse, ActionsSentNotifsForGroupData, ActionsSentNotifsForGroupResponse, ActionsClearDbData, ActionsSetTestRelationsData, ActionsLikeActivityData, ActionsLikeActivityResponse, ActionsUnlikeActivityData, ActionsUnlikeActivityResponse, ActionsAddActivityCommentData, ActionsAddActivityCommentResponse, ActionsUpdateActivityData, ActionsUpdateActivityResponse, ActionsDismissActionData, ActionsDismissActionResponse, ActionsCreateActivityData, ActionsCreateActivityResponse, ActionsArchiveData, ActionsArchiveResponse, ActionsUnarchiveData, ActionsUnarchiveResponse, ActionsReminderGroupsForEventData, ActionsReminderGroupsForEventResponse, ActionsCreateUpdateData, ActionsCreateUpdateResponse, ActionsUpdateUpdateData, ActionsUpdateUpdateResponse, ActionsDeleteUpdateData, ActionsAllUpdatesData, ActionsAllUpdatesResponse, ActionsSuitesData, ActionsSuitesResponse, ActionsSuiteData, ActionsSuiteResponse, ActionsCreateSuiteData, ActionsCreateSuiteResponse, ActionsBatchUpdateSuiteEventsData, ActionsAddSuiteEventData, ActionsAddSuiteEventResponse, ActionsDeleteSuiteEventData, ActionsDeleteSuiteEventResponse, ActionsTentativePlansForGroupData, ActionsTentativePlansForGroupResponse, ActionsPreviewEmailHtmlData, ActionsPreviewEmailHtmlResponse, ActionsPreviewTextMessageData, ActionsPreviewTextMessageResponse, ActionsReloadAllActionUsersJoinedData, ActionsReloadAllActionUsersCompletedData, ActionsExportActionData, ActionsExportActionResponse, ActionsPasteJsonData, ActionsPasteJsonResponse, ActionsReminderPlansOverviewData, ActionsReminderPlansOverviewResponse, ActionsSuspendPlansData, ActionsSuspendPlansResponse, ActionsGetShareLinkData, ActionsGetShareLinkResponse, ActionsShareLinksForFormData, ActionsShareLinksForFormResponse, ActionsShareUrlStatsData, ActionsShareUrlStatsResponse, ActionsActionRelationsData, ActionsActionRelationsResponse, ActionsActionRelationsForUserData, ActionsActionRelationsForUserResponse, ActionsGetCommunityMemberInfoAdminData, ActionsGetCommunityMemberInfoAdminResponse, ActionsGetCommunityMemberInfoData, ActionsGetCommunityMemberInfoResponse, NotifsFindAllData, NotifsFindAllResponse, NotifsSetReadData, NotifsSetReadAllData, NotifsNotifsForUserData, NotifsNotifsForUserResponse, NotifsLinkClickData, NotifsLinkClickResponse, ForumFindAllPostsData, ForumFindAllPostsResponse, ForumCreatePostData, ForumCreatePostResponse, ForumFindPostsByActionData, ForumFindPostsByActionResponse, ForumRemovePostData, ForumFindOnePostData, ForumFindOnePostResponse, ForumUpdatePostData, ForumUpdatePostResponse, ForumFindCommentsForPostData, ForumFindCommentsForPostResponse, ForumFindCommentsForActivityData, ForumFindCommentsForActivityResponse, ForumFindCommentsForActionData, ForumFindCommentsForActionResponse, ForumFindPostsByUserData, ForumFindPostsByUserResponse, ForumFindCommentsByUserData, ForumFindCommentsByUserResponse, ForumFindForumCommentsByUserData, ForumFindForumCommentsByUserResponse, ForumCreateCommentData, ForumCreateCommentResponse, ForumDeleteCommentData, ForumUpdateCommentData, ForumUpdateCommentResponse, ForumLikeCommentData, ForumLikeCommentResponse, ForumUnlikeCommentData, ForumUnlikeCommentResponse, ForumLikePostData, ForumLikePostResponse, ForumUnlikePostData, ForumUnlikePostResponse, ForumGetPostsForAdminData, ForumGetPostsForAdminResponse, ForumUpdatePostExpertsData, ForumUpdatePostExpertsResponse, GeoSearchCityData, GeoSearchCityResponse, GeoLoadCountryDataData, GeoLoadCityDataData, PaymentsCreatePaymentIntentData, PaymentsCreatePaymentIntentResponse, PaymentsSetPartialProfileData, PaymentsWebhookData, PaymentsPaymentMethodData, PaymentsPaymentMethodResponse, PaymentsClearPaymentMethodsData, AdminViewerGetTablesData, AdminViewerGetTablesResponse, AdminViewerGetTableDataData, AdminViewerGetTableDataResponse, AdminViewerDeleteRecordsData, AdminViewerDeleteRecordsResponse, AdminViewerCreateRecordData, AdminViewerCreateRecordResponse, AdminViewerUpdateRecordData, AdminViewerUpdateRecordResponse, SearchAllData, SearchAllResponse, SearchSaveSelectedData, TasksSubmitFormData, TasksSubmitFormResponse, TasksSubmitPublicFormData, TasksSubmitPublicFormResponse, TasksCreateFormData, TasksCreateFormResponse, TasksListFormsData, TasksListFormsResponse, TasksGetFormResponsesData, TasksGetFormResponsesResponse, TasksGetMyFormResponseData, TasksGetMyFormResponseResponse, TasksGetFormData, TasksGetFormResponse, TasksUpdateFormData, TasksUpdateFormResponse, TasksDeleteFormData, TasksCustomValidatorsData, TasksCustomValidatorsResponse, TasksRunValidatorData, TasksRunValidatorResponse, TasksFindOneCustomValidatorData, TasksFindOneCustomValidatorResponse, TasksCreateCustomValidatorData, TasksCreateCustomValidatorResponse, TasksOptoutData, TasksOptoutResponse, TasksGetFormsForUserSidData, TasksGetFormsForUserSidResponse, AnalyticsGetTimeSpentPerUserData, AnalyticsGetTimeSpentPerUserResponse, AnalyticsGetTimeSpentPerUserTotalData, AnalyticsGetTimeSpentPerUserTotalResponse, AnalyticsGetDailyStatsData, AnalyticsGetDailyStatsResponse, AnalyticsGetActionStatsData, AnalyticsGetActionStatsResponse, AnalyticsRecalculateActionStatsData, AnalyticsRecalculateActionStatsResponse, AnalyticsGetMemberCompletionRetentionData, AnalyticsGetMemberCompletionRetentionResponse, AnalyticsGetTimeToChurnSamplesData, AnalyticsGetTimeToChurnSamplesResponse, AnalyticsGetAggregateStatsData, AnalyticsGetAggregateStatsResponse, AnalyticsGetContractStatusHistoryData, AnalyticsGetContractStatusHistoryResponse } from './types.gen';
import { client as _heyApiClient } from './client.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

export const appHealthCheck = <ThrowOnError extends boolean = false>(options?: Options<AppHealthCheckData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AppHealthCheckResponse, unknown, ThrowOnError>({
        url: '/',
        ...options
    });
};

export const appMetrics = <ThrowOnError extends boolean = false>(options?: Options<AppMetricsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AppMetricsResponse, unknown, ThrowOnError>({
        url: '/metrics',
        ...options
    });
};

export const authLogin = <ThrowOnError extends boolean = false>(options: Options<AuthLoginData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AuthLoginResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/auth/login',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const authAdminLogin = <ThrowOnError extends boolean = false>(options: Options<AuthAdminLoginData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AuthAdminLoginResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/auth/admin/login',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const authRegister = <ThrowOnError extends boolean = false>(options: Options<AuthRegisterData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AuthRegisterResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/auth/register',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const authRefreshTokens = <ThrowOnError extends boolean = false>(options?: Options<AuthRefreshTokensData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<AuthRefreshTokensResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/auth/refresh',
        ...options
    });
};

export const authMe = <ThrowOnError extends boolean = false>(options?: Options<AuthMeData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AuthMeResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/auth/me',
        ...options
    });
};

export const authLogout = <ThrowOnError extends boolean = false>(options?: Options<AuthLogoutData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/auth/logout',
        ...options
    });
};

export const authForgotPassword = <ThrowOnError extends boolean = false>(options: Options<AuthForgotPasswordData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/auth/forgot-password',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const authResetPassword = <ThrowOnError extends boolean = false>(options: Options<AuthResetPasswordData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/auth/reset-password',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const authImpersonate = <ThrowOnError extends boolean = false>(options: Options<AuthImpersonateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/auth/impersonate/{userId}',
        ...options
    });
};

export const userFindMe = <ThrowOnError extends boolean = false>(options?: Options<UserFindMeData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<UserFindMeResponse, unknown, ThrowOnError>({
        url: '/user/me',
        ...options
    });
};

export const userOnboarding = <ThrowOnError extends boolean = false>(options: Options<UserOnboardingData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
        url: '/user/onboarding',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const userSignContract = <ThrowOnError extends boolean = false>(options?: Options<UserSignContractData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<UserSignContractResponse, unknown, ThrowOnError>({
        url: '/user/signcontract',
        ...options
    });
};

export const userSuspendContract = <ThrowOnError extends boolean = false>(options?: Options<UserSuspendContractData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<UserSuspendContractResponse, unknown, ThrowOnError>({
        url: '/user/suspendcontract',
        ...options
    });
};

export const userGetAwayRanges = <ThrowOnError extends boolean = false>(options?: Options<UserGetAwayRangesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<UserGetAwayRangesResponse, unknown, ThrowOnError>({
        url: '/user/awayranges',
        ...options
    });
};

export const userCreateAwayRange = <ThrowOnError extends boolean = false>(options: Options<UserCreateAwayRangeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UserCreateAwayRangeResponse, unknown, ThrowOnError>({
        url: '/user/awayranges',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const userDeleteAwayRange = <ThrowOnError extends boolean = false>(options: Options<UserDeleteAwayRangeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<UserDeleteAwayRangeResponse, unknown, ThrowOnError>({
        url: '/user/awayranges/{id}',
        ...options
    });
};

export const userGetAwayRangeForUser = <ThrowOnError extends boolean = false>(options: Options<UserGetAwayRangeForUserData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<UserGetAwayRangeForUserResponse, unknown, ThrowOnError>({
        url: '/user/awayranges/{id}',
        ...options
    });
};

export const userUpdateAwayRange = <ThrowOnError extends boolean = false>(options: Options<UserUpdateAwayRangeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UserUpdateAwayRangeResponse, unknown, ThrowOnError>({
        url: '/user/awayranges/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const userUpdate = <ThrowOnError extends boolean = false>(options: Options<UserUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UserUpdateResponse, unknown, ThrowOnError>({
        url: '/user/update',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const userMyLocation = <ThrowOnError extends boolean = false>(options?: Options<UserMyLocationData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<UserMyLocationResponse, unknown, ThrowOnError>({
        url: '/user/mylocation',
        ...options
    });
};

/**
 * Cancel a request or remove an existing friend
 */
export const userRemoveFriend = <ThrowOnError extends boolean = false>(options: Options<UserRemoveFriendData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<unknown, unknown, ThrowOnError>({
        url: '/user/friends/{targetUserId}',
        ...options
    });
};

/**
 * Send a friend request
 */
export const userRequestFriend = <ThrowOnError extends boolean = false>(options: Options<UserRequestFriendData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
        url: '/user/friends/{targetUserId}',
        ...options
    });
};

/**
 * Accept a pending friend request
 */
export const userAcceptFriendRequest = <ThrowOnError extends boolean = false>(options: Options<UserAcceptFriendRequestData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<unknown, unknown, ThrowOnError>({
        url: '/user/friends/{requesterId}/accept',
        ...options
    });
};

/**
 * Decline a pending friend request
 */
export const userDeclineFriendRequest = <ThrowOnError extends boolean = false>(options: Options<UserDeclineFriendRequestData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<unknown, unknown, ThrowOnError>({
        url: '/user/friends/{requesterId}/decline',
        ...options
    });
};

/**
 * Requests other users sent to me (pending)
 */
export const userListReceivedRequests = <ThrowOnError extends boolean = false>(options?: Options<UserListReceivedRequestsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<UserListReceivedRequestsResponse, unknown, ThrowOnError>({
        url: '/user/friends/requests/received',
        ...options
    });
};

/**
 * Requests I sent that are still pending
 */
export const userListSentRequests = <ThrowOnError extends boolean = false>(options?: Options<UserListSentRequestsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<UserListSentRequestsResponse, unknown, ThrowOnError>({
        url: '/user/friends/requests/sent',
        ...options
    });
};

export const userMyFriendRelationship = <ThrowOnError extends boolean = false>(options: Options<UserMyFriendRelationshipData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<UserMyFriendRelationshipResponse, unknown, ThrowOnError>({
        url: '/user/myfriendrelationship/{id}',
        ...options
    });
};

export const userPrefill = <ThrowOnError extends boolean = false>(options: Options<UserPrefillData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<UserPrefillResponse, unknown, ThrowOnError>({
        url: '/user/prefill/{id}',
        ...options
    });
};

export const userListFriends = <ThrowOnError extends boolean = false>(options: Options<UserListFriendsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<UserListFriendsResponse, unknown, ThrowOnError>({
        url: '/user/listfriends/{id}',
        ...options
    });
};

export const userListMessageableUsers = <ThrowOnError extends boolean = false>(options?: Options<UserListMessageableUsersData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<UserListMessageableUsersResponse, unknown, ThrowOnError>({
        url: '/user/listMessageableUsers',
        ...options
    });
};

/**
 * Count the number of friends a user has referred
 */
export const userCountReferred = <ThrowOnError extends boolean = false>(options: Options<UserCountReferredData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<UserCountReferredResponse, unknown, ThrowOnError>({
        url: '/user/countreferred/{id}',
        ...options
    });
};

export const userList = <ThrowOnError extends boolean = false>(options?: Options<UserListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<UserListResponse, unknown, ThrowOnError>({
        url: '/user/list',
        ...options
    });
};

export const userListPublic = <ThrowOnError extends boolean = false>(options?: Options<UserListPublicData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<UserListPublicResponse, unknown, ThrowOnError>({
        url: '/user/list-public',
        ...options
    });
};

export const userMembers = <ThrowOnError extends boolean = false>(options?: Options<UserMembersData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<UserMembersResponse, unknown, ThrowOnError>({
        url: '/user/members',
        ...options
    });
};

export const userMembersPublic = <ThrowOnError extends boolean = false>(options?: Options<UserMembersPublicData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<UserMembersPublicResponse, unknown, ThrowOnError>({
        url: '/user/members-public',
        ...options
    });
};

export const userMembersWithFriends = <ThrowOnError extends boolean = false>(options: Options<UserMembersWithFriendsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<UserMembersWithFriendsResponse, unknown, ThrowOnError>({
        url: '/user/membersWithFriends',
        ...options
    });
};

export const userMyProfile = <ThrowOnError extends boolean = false>(options?: Options<UserMyProfileData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<UserMyProfileResponse, unknown, ThrowOnError>({
        url: '/user/myprofile',
        ...options
    });
};

export const userCount = <ThrowOnError extends boolean = false>(options?: Options<UserCountData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<UserCountResponse, unknown, ThrowOnError>({
        url: '/user/count',
        ...options
    });
};

export const userFindOne = <ThrowOnError extends boolean = false>(options: Options<UserFindOneData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<UserFindOneResponse, unknown, ThrowOnError>({
        url: '/user/slug/{id}',
        ...options
    });
};

export const userVerifyEmail = <ThrowOnError extends boolean = false>(options: Options<UserVerifyEmailData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UserVerifyEmailResponse, unknown, ThrowOnError>({
        url: '/user/verifyEmail',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const userGetCommunities = <ThrowOnError extends boolean = false>(options?: Options<UserGetCommunitiesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<UserGetCommunitiesResponse, unknown, ThrowOnError>({
        url: '/user/communities',
        ...options
    });
};

export const userCreateCommunity = <ThrowOnError extends boolean = false>(options: Options<UserCreateCommunityData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UserCreateCommunityResponse, unknown, ThrowOnError>({
        url: '/user/communities',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const userDeleteCommunity = <ThrowOnError extends boolean = false>(options: Options<UserDeleteCommunityData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<unknown, unknown, ThrowOnError>({
        url: '/user/communities/{communityId}',
        ...options
    });
};

export const userUpdateCommunity = <ThrowOnError extends boolean = false>(options: Options<UserUpdateCommunityData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UserUpdateCommunityResponse, unknown, ThrowOnError>({
        url: '/user/communities/{communityId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const userAddMemberToCommunity = <ThrowOnError extends boolean = false>(options: Options<UserAddMemberToCommunityData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UserAddMemberToCommunityResponse, unknown, ThrowOnError>({
        url: '/user/communities/{communityId}/addMember',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const userRemoveMemberFromCommunity = <ThrowOnError extends boolean = false>(options: Options<UserRemoveMemberFromCommunityData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UserRemoveMemberFromCommunityResponse, unknown, ThrowOnError>({
        url: '/user/communities/{communityId}/removeMember',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const userAddLeaderToCommunity = <ThrowOnError extends boolean = false>(options: Options<UserAddLeaderToCommunityData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UserAddLeaderToCommunityResponse, unknown, ThrowOnError>({
        url: '/user/communities/{communityId}/addLeader',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const userRemoveLeaderFromCommunity = <ThrowOnError extends boolean = false>(options: Options<UserRemoveLeaderFromCommunityData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UserRemoveLeaderFromCommunityResponse, unknown, ThrowOnError>({
        url: '/user/communities/{communityId}/removeLeader',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const userCreateTag = <ThrowOnError extends boolean = false>(options: Options<UserCreateTagData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UserCreateTagResponse, unknown, ThrowOnError>({
        url: '/user/createTag',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const userGetTags = <ThrowOnError extends boolean = false>(options?: Options<UserGetTagsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<UserGetTagsResponse, unknown, ThrowOnError>({
        url: '/user/tags',
        ...options
    });
};

export const userAddUserToTag = <ThrowOnError extends boolean = false>(options: Options<UserAddUserToTagData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UserAddUserToTagResponse, unknown, ThrowOnError>({
        url: '/user/tags/{tagId}/addUser',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const userRemoveUserFromTag = <ThrowOnError extends boolean = false>(options: Options<UserRemoveUserFromTagData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UserRemoveUserFromTagResponse, unknown, ThrowOnError>({
        url: '/user/tags/{tagId}/removeUser',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const userUpdateTag = <ThrowOnError extends boolean = false>(options: Options<UserUpdateTagData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UserUpdateTagResponse, unknown, ThrowOnError>({
        url: '/user/tags/{tagId}/update',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const userDeleteTag = <ThrowOnError extends boolean = false>(options: Options<UserDeleteTagData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<unknown, unknown, ThrowOnError>({
        url: '/user/tags/{tagId}',
        ...options
    });
};

export const userReferrerProfile = <ThrowOnError extends boolean = false>(options: Options<UserReferrerProfileData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<UserReferrerProfileResponse, unknown, ThrowOnError>({
        url: '/user/referrerProfile/{code}',
        ...options
    });
};

export const userOnetimeInvite = <ThrowOnError extends boolean = false>(options: Options<UserOnetimeInviteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<UserOnetimeInviteResponse, unknown, ThrowOnError>({
        url: '/user/onetimeInvite/{code}',
        ...options
    });
};

export const userRequestOnetimeInvite = <ThrowOnError extends boolean = false>(options: Options<UserRequestOnetimeInviteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UserRequestOnetimeInviteResponse, unknown, ThrowOnError>({
        url: '/user/onetimeInvite/request',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const userApproveOnetimeInvite = <ThrowOnError extends boolean = false>(options: Options<UserApproveOnetimeInviteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UserApproveOnetimeInviteResponse, unknown, ThrowOnError>({
        url: '/user/onetimeInvite/{inviteId}/approve',
        ...options
    });
};

export const userRejectOnetimeInvite = <ThrowOnError extends boolean = false>(options: Options<UserRejectOnetimeInviteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
        url: '/user/onetimeInvite/{inviteId}/reject',
        ...options
    });
};

export const userCreateOnetimeInvite = <ThrowOnError extends boolean = false>(options: Options<UserCreateOnetimeInviteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UserCreateOnetimeInviteResponse, unknown, ThrowOnError>({
        url: '/user/onetimeInvite/create',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const userCreateCommunityInvite = <ThrowOnError extends boolean = false>(options: Options<UserCreateCommunityInviteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UserCreateCommunityInviteResponse, unknown, ThrowOnError>({
        url: '/user/createCommunityInvite',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const userGetCommunityInvites = <ThrowOnError extends boolean = false>(options: Options<UserGetCommunityInvitesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<UserGetCommunityInvitesResponse, unknown, ThrowOnError>({
        url: '/user/communityInvites/{communityId}',
        ...options
    });
};

export const userDeleteOnetimeInvite = <ThrowOnError extends boolean = false>(options: Options<UserDeleteOnetimeInviteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<unknown, unknown, ThrowOnError>({
        url: '/user/onetimeInvites/{inviteId}',
        ...options
    });
};

export const userDeleteCommunityInvite = <ThrowOnError extends boolean = false>(options: Options<UserDeleteCommunityInviteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<unknown, unknown, ThrowOnError>({
        url: '/user/communityInvites/{inviteId}',
        ...options
    });
};

export const userGetCommunityInvitesForUser = <ThrowOnError extends boolean = false>(options?: Options<UserGetCommunityInvitesForUserData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<UserGetCommunityInvitesForUserResponse, unknown, ThrowOnError>({
        url: '/user/communityInvites',
        ...options
    });
};

export const userGetOnetimeInvites = <ThrowOnError extends boolean = false>(options?: Options<UserGetOnetimeInvitesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<UserGetOnetimeInvitesResponse, unknown, ThrowOnError>({
        url: '/user/onetimeInvites',
        ...options
    });
};

export const userGetOnetimeInvitesByCommunity = <ThrowOnError extends boolean = false>(options: Options<UserGetOnetimeInvitesByCommunityData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<UserGetOnetimeInvitesByCommunityResponse, unknown, ThrowOnError>({
        url: '/user/onetimeInvites/{communityId}',
        ...options
    });
};

export const userGetOnetimeInvitesByRequester = <ThrowOnError extends boolean = false>(options: Options<UserGetOnetimeInvitesByRequesterData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<UserGetOnetimeInvitesByRequesterResponse, unknown, ThrowOnError>({
        url: '/user/onetimeInvites/{communityId}/my',
        ...options
    });
};

export const userGetMyCommunities = <ThrowOnError extends boolean = false>(options?: Options<UserGetMyCommunitiesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<UserGetMyCommunitiesResponse, unknown, ThrowOnError>({
        url: '/user/myCommunities',
        ...options
    });
};

export const userGetCommunityMemberContactInfo = <ThrowOnError extends boolean = false>(options?: Options<UserGetCommunityMemberContactInfoData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<UserGetCommunityMemberContactInfoResponse, unknown, ThrowOnError>({
        url: '/user/communityMemberContactInfo',
        ...options
    });
};

export const userGetCommunityMemberContactInfoAdmin = <ThrowOnError extends boolean = false>(options: Options<UserGetCommunityMemberContactInfoAdminData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<UserGetCommunityMemberContactInfoAdminResponse, unknown, ThrowOnError>({
        url: '/user/communityMemberContactInfo/{communityId}',
        ...options
    });
};

export const userGetAllMemberContactInfo = <ThrowOnError extends boolean = false>(options?: Options<UserGetAllMemberContactInfoData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<UserGetAllMemberContactInfoResponse, unknown, ThrowOnError>({
        url: '/user/memberContactInfo',
        ...options
    });
};

export const userAcceptCommunityInvite = <ThrowOnError extends boolean = false>(options: Options<UserAcceptCommunityInviteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
        url: '/user/communityInvites/{inviteId}/accept',
        ...options
    });
};

export const userRejectCommunityInvite = <ThrowOnError extends boolean = false>(options: Options<UserRejectCommunityInviteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
        url: '/user/communityInvites/{inviteId}/reject',
        ...options
    });
};

export const userLeaveCommunity = <ThrowOnError extends boolean = false>(options: Options<UserLeaveCommunityData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
        url: '/user/communities/{communityId}/leave',
        ...options
    });
};

export const userRegisterDevice = <ThrowOnError extends boolean = false>(options: Options<UserRegisterDeviceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UserRegisterDeviceResponse, unknown, ThrowOnError>({
        url: '/user/registerDevice',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const userSendPushNotification = <ThrowOnError extends boolean = false>(options: Options<UserSendPushNotificationData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UserSendPushNotificationResponse, unknown, ThrowOnError>({
        url: '/user/sendPushNotification',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const imagesGetImage = <ThrowOnError extends boolean = false>(options: Options<ImagesGetImageData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ImagesGetImageResponse, unknown, ThrowOnError>({
        url: '/images/{key}',
        ...options
    });
};

export const imagesDeleteImage = <ThrowOnError extends boolean = false>(options: Options<ImagesDeleteImageData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<unknown, unknown, ThrowOnError>({
        url: '/images/{id}',
        ...options
    });
};

export const imagesUploadImage = <ThrowOnError extends boolean = false>(options: Options<ImagesUploadImageData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ImagesUploadImageResponse, unknown, ThrowOnError>({
        url: '/images/uploadImage',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const mailgunWebhookHandle = <ThrowOnError extends boolean = false>(options?: Options<MailgunWebhookHandleData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
        url: '/mailgun/handle-event',
        ...options
    });
};

export const conversationGetAllConversationsForAdmin = <ThrowOnError extends boolean = false>(options?: Options<ConversationGetAllConversationsForAdminData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ConversationGetAllConversationsForAdminResponse, unknown, ThrowOnError>({
        url: '/messaging/conversations/admin',
        ...options
    });
};

export const conversationGetMyConversations = <ThrowOnError extends boolean = false>(options?: Options<ConversationGetMyConversationsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ConversationGetMyConversationsResponse, unknown, ThrowOnError>({
        url: '/messaging/conversations',
        ...options
    });
};

export const conversationGetCommunityConversations = <ThrowOnError extends boolean = false>(options: Options<ConversationGetCommunityConversationsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ConversationGetCommunityConversationsResponse, unknown, ThrowOnError>({
        url: '/messaging/conversations/community/{communityId}',
        ...options
    });
};

export const conversationCreateDirectConversation = <ThrowOnError extends boolean = false>(options: Options<ConversationCreateDirectConversationData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ConversationCreateDirectConversationResponse, unknown, ThrowOnError>({
        url: '/messaging/conversations/direct',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const conversationCreateGroupConversation = <ThrowOnError extends boolean = false>(options: Options<ConversationCreateGroupConversationData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ConversationCreateGroupConversationResponse, unknown, ThrowOnError>({
        url: '/messaging/conversations/group',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const conversationUpdateInfo = <ThrowOnError extends boolean = false>(options: Options<ConversationUpdateInfoData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ConversationUpdateInfoResponse, unknown, ThrowOnError>({
        url: '/messaging/conversations/{conversationId}/update',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const conversationAcceptInvite = <ThrowOnError extends boolean = false>(options: Options<ConversationAcceptInviteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ConversationAcceptInviteResponse, unknown, ThrowOnError>({
        url: '/messaging/conversations/{conversationId}/accept',
        ...options
    });
};

export const conversationDeclineInvite = <ThrowOnError extends boolean = false>(options: Options<ConversationDeclineInviteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ConversationDeclineInviteResponse, unknown, ThrowOnError>({
        url: '/messaging/conversations/{conversationId}/decline',
        ...options
    });
};

export const conversationAddParticipant = <ThrowOnError extends boolean = false>(options: Options<ConversationAddParticipantData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ConversationAddParticipantResponse, unknown, ThrowOnError>({
        url: '/messaging/conversations/{conversationId}/participants',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const conversationRemoveParticipant = <ThrowOnError extends boolean = false>(options: Options<ConversationRemoveParticipantData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<ConversationRemoveParticipantResponse, unknown, ThrowOnError>({
        url: '/messaging/conversations/{conversationId}/participants/{userId}',
        ...options
    });
};

export const conversationMarkRead = <ThrowOnError extends boolean = false>(options: Options<ConversationMarkReadData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ConversationMarkReadResponse, unknown, ThrowOnError>({
        url: '/messaging/conversations/{conversationId}/read',
        ...options
    });
};

export const conversationGetUnreadMessages = <ThrowOnError extends boolean = false>(options?: Options<ConversationGetUnreadMessagesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ConversationGetUnreadMessagesResponse, unknown, ThrowOnError>({
        url: '/messaging/conversations/unread',
        ...options
    });
};

export const conversationLeave = <ThrowOnError extends boolean = false>(options: Options<ConversationLeaveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ConversationLeaveResponse, unknown, ThrowOnError>({
        url: '/messaging/conversations/{conversationId}/leave',
        ...options
    });
};

export const messageGetConversationMessagesForAdmin = <ThrowOnError extends boolean = false>(options: Options<MessageGetConversationMessagesForAdminData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MessageGetConversationMessagesForAdminResponse, unknown, ThrowOnError>({
        url: '/messaging/messages/admin/{conversationId}',
        ...options
    });
};

export const messageSendMessage = <ThrowOnError extends boolean = false>(options: Options<MessageSendMessageData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<MessageSendMessageResponse, unknown, ThrowOnError>({
        url: '/messaging/messages',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const messageGetMessages = <ThrowOnError extends boolean = false>(options: Options<MessageGetMessagesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MessageGetMessagesResponse, unknown, ThrowOnError>({
        url: '/messaging/messages/{conversationId}',
        ...options
    });
};

export const actionsJoin = <ThrowOnError extends boolean = false>(options: Options<ActionsJoinData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ActionsJoinResponse, unknown, ThrowOnError>({
        url: '/actions/join/{id}',
        ...options
    });
};

export const actionsDecline = <ThrowOnError extends boolean = false>(options: Options<ActionsDeclineData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ActionsDeclineResponse, unknown, ThrowOnError>({
        url: '/actions/decline/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const actionsOptout = <ThrowOnError extends boolean = false>(options: Options<ActionsOptoutData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ActionsOptoutResponse, unknown, ThrowOnError>({
        url: '/actions/optout/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const actionsComplete = <ThrowOnError extends boolean = false>(options: Options<ActionsCompleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ActionsCompleteResponse, unknown, ThrowOnError>({
        url: '/actions/complete/{id}',
        ...options
    });
};

/**
 * Get the authenticated user's relation to a single action
 */
export const actionsMyStatus = <ThrowOnError extends boolean = false>(options: Options<ActionsMyStatusData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ActionsMyStatusResponse, unknown, ThrowOnError>({
        url: '/actions/myStatus/{id}',
        ...options
    });
};

export const actionsFindAll = <ThrowOnError extends boolean = false>(options?: Options<ActionsFindAllData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ActionsFindAllResponse, unknown, ThrowOnError>({
        url: '/actions',
        ...options
    });
};

export const actionsFindAllLoggedIn = <ThrowOnError extends boolean = false>(options: Options<ActionsFindAllLoggedInData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ActionsFindAllLoggedInResponse, unknown, ThrowOnError>({
        url: '/actions/loggedIn',
        ...options
    });
};

export const actionsMyActivity = <ThrowOnError extends boolean = false>(options?: Options<ActionsMyActivityData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ActionsMyActivityResponse, unknown, ThrowOnError>({
        url: '/actions/myActivity',
        ...options
    });
};

export const actionsUserLocations = <ThrowOnError extends boolean = false>(options: Options<ActionsUserLocationsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ActionsUserLocationsResponse, unknown, ThrowOnError>({
        url: '/actions/userlocations/{id}',
        ...options
    });
};

/**
 * Get recent activities from all actions for the feed
 */
export const actionsGetActivityFeed = <ThrowOnError extends boolean = false>(options: Options<ActionsGetActivityFeedData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ActionsGetActivityFeedResponse, unknown, ThrowOnError>({
        url: '/actions/activities/feed',
        ...options
    });
};

export const actionsGetActivity = <ThrowOnError extends boolean = false>(options: Options<ActionsGetActivityData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ActionsGetActivityResponse, unknown, ThrowOnError>({
        url: '/actions/activities/{id}',
        ...options
    });
};

export const actionsGetEvent = <ThrowOnError extends boolean = false>(options: Options<ActionsGetEventData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ActionsGetEventResponse, unknown, ThrowOnError>({
        url: '/actions/events/{id}',
        ...options
    });
};

export const actionsGetNotificationSchedule = <ThrowOnError extends boolean = false>(options: Options<ActionsGetNotificationScheduleData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ActionsGetNotificationScheduleResponse, unknown, ThrowOnError>({
        url: '/actions/notification-schedule',
        ...options
    });
};

/**
 * Get recent activities for an action
 */
export const actionsGetActionActivities = <ThrowOnError extends boolean = false>(options: Options<ActionsGetActionActivitiesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ActionsGetActionActivitiesResponse, unknown, ThrowOnError>({
        url: '/actions/{id}/activities',
        ...options
    });
};

export const actionsFindAllWithDrafts = <ThrowOnError extends boolean = false>(options?: Options<ActionsFindAllWithDraftsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ActionsFindAllWithDraftsResponse, unknown, ThrowOnError>({
        url: '/actions/all',
        ...options
    });
};

/**
 * SSE endpoint for join counts on a single action
 */
export const actionsSseActionCount = <ThrowOnError extends boolean = false>(options: Options<ActionsSseActionCountData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/actions/live/{id}',
        ...options
    });
};

/**
 * SSE endpoint for join counts on multiple actions
 */
export const actionsLiveList = <ThrowOnError extends boolean = false>(options: Options<ActionsLiveListData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/actions/live-list',
        ...options
    });
};

export const actionsFriendActivityForAction = <ThrowOnError extends boolean = false>(options: Options<ActionsFriendActivityForActionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ActionsFriendActivityForActionResponse, unknown, ThrowOnError>({
        url: '/actions/friendActivity/{actionId}',
        ...options
    });
};

export const actionsFriendActivity = <ThrowOnError extends boolean = false>(options: Options<ActionsFriendActivityData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ActionsFriendActivityResponse, unknown, ThrowOnError>({
        url: '/actions/friendActivity',
        ...options
    });
};

export const actionsCommunityActivity = <ThrowOnError extends boolean = false>(options: Options<ActionsCommunityActivityData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ActionsCommunityActivityResponse, unknown, ThrowOnError>({
        url: '/actions/communityActivity',
        ...options
    });
};

export const actionsFindOne = <ThrowOnError extends boolean = false>(options: Options<ActionsFindOneData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ActionsFindOneResponse, unknown, ThrowOnError>({
        url: '/actions/slug/{id}',
        ...options
    });
};

export const actionsFindOneAdmin = <ThrowOnError extends boolean = false>(options: Options<ActionsFindOneAdminData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ActionsFindOneAdminResponse, unknown, ThrowOnError>({
        url: '/actions/adminslug/{id}',
        ...options
    });
};

export const actionsCreate = <ThrowOnError extends boolean = false>(options: Options<ActionsCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ActionsCreateResponse, unknown, ThrowOnError>({
        url: '/actions/create',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const actionsRemove = <ThrowOnError extends boolean = false>(options: Options<ActionsRemoveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<unknown, unknown, ThrowOnError>({
        url: '/actions/{id}',
        ...options
    });
};

export const actionsUpdate = <ThrowOnError extends boolean = false>(options: Options<ActionsUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<ActionsUpdateResponse, unknown, ThrowOnError>({
        url: '/actions/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const actionsFindCompletedForUser = <ThrowOnError extends boolean = false>(options: Options<ActionsFindCompletedForUserData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ActionsFindCompletedForUserResponse, unknown, ThrowOnError>({
        url: '/actions/completed/{id}',
        ...options
    });
};

export const actionsAddEvent = <ThrowOnError extends boolean = false>(options: Options<ActionsAddEventData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ActionsAddEventResponse, unknown, ThrowOnError>({
        url: '/actions/{id}/events',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const actionsUpdateReminderGroup = <ThrowOnError extends boolean = false>(options: Options<ActionsUpdateReminderGroupData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<ActionsUpdateReminderGroupResponse, unknown, ThrowOnError>({
        url: '/actions/remindergroups/{groupId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const actionsCreateReminderGroup = <ThrowOnError extends boolean = false>(options: Options<ActionsCreateReminderGroupData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ActionsCreateReminderGroupResponse, unknown, ThrowOnError>({
        url: '/actions/events/{eventId}/createremindergroup',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const actionsDeleteReminderGroup = <ThrowOnError extends boolean = false>(options: Options<ActionsDeleteReminderGroupData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<unknown, unknown, ThrowOnError>({
        url: '/actions/reminders/{groupId}',
        ...options
    });
};

export const actionsPlansForGroup = <ThrowOnError extends boolean = false>(options: Options<ActionsPlansForGroupData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ActionsPlansForGroupResponse, unknown, ThrowOnError>({
        url: '/actions/plansForGroup/{groupId}',
        ...options
    });
};

export const actionsSentNotifsForGroup = <ThrowOnError extends boolean = false>(options: Options<ActionsSentNotifsForGroupData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ActionsSentNotifsForGroupResponse, unknown, ThrowOnError>({
        url: '/actions/sentNotifsForGroup/{groupId}',
        ...options
    });
};

export const actionsClearDb = <ThrowOnError extends boolean = false>(options?: Options<ActionsClearDbData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
        url: '/actions/clearDb',
        ...options
    });
};

export const actionsSetTestRelations = <ThrowOnError extends boolean = false>(options?: Options<ActionsSetTestRelationsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
        url: '/actions/setTestRelations',
        ...options
    });
};

export const actionsLikeActivity = <ThrowOnError extends boolean = false>(options: Options<ActionsLikeActivityData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ActionsLikeActivityResponse, unknown, ThrowOnError>({
        url: '/actions/likeActivity/{id}',
        ...options
    });
};

export const actionsUnlikeActivity = <ThrowOnError extends boolean = false>(options: Options<ActionsUnlikeActivityData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ActionsUnlikeActivityResponse, unknown, ThrowOnError>({
        url: '/actions/unlikeActivity/{id}',
        ...options
    });
};

export const actionsAddActivityComment = <ThrowOnError extends boolean = false>(options: Options<ActionsAddActivityCommentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ActionsAddActivityCommentResponse, unknown, ThrowOnError>({
        url: '/actions/addActivityComment/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const actionsUpdateActivity = <ThrowOnError extends boolean = false>(options: Options<ActionsUpdateActivityData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ActionsUpdateActivityResponse, unknown, ThrowOnError>({
        url: '/actions/updateActivity/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const actionsDismissAction = <ThrowOnError extends boolean = false>(options: Options<ActionsDismissActionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ActionsDismissActionResponse, unknown, ThrowOnError>({
        url: '/actions/dismiss/{id}',
        ...options
    });
};

export const actionsCreateActivity = <ThrowOnError extends boolean = false>(options: Options<ActionsCreateActivityData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ActionsCreateActivityResponse, unknown, ThrowOnError>({
        url: '/actions/createActivity',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const actionsArchive = <ThrowOnError extends boolean = false>(options: Options<ActionsArchiveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ActionsArchiveResponse, unknown, ThrowOnError>({
        url: '/actions/archive/{id}',
        ...options
    });
};

export const actionsUnarchive = <ThrowOnError extends boolean = false>(options: Options<ActionsUnarchiveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ActionsUnarchiveResponse, unknown, ThrowOnError>({
        url: '/actions/unarchive/{id}',
        ...options
    });
};

export const actionsReminderGroupsForEvent = <ThrowOnError extends boolean = false>(options: Options<ActionsReminderGroupsForEventData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ActionsReminderGroupsForEventResponse, unknown, ThrowOnError>({
        url: '/actions/reminderGroupsForEvent/{id}',
        ...options
    });
};

export const actionsCreateUpdate = <ThrowOnError extends boolean = false>(options: Options<ActionsCreateUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ActionsCreateUpdateResponse, unknown, ThrowOnError>({
        url: '/actions/createUpdate/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const actionsUpdateUpdate = <ThrowOnError extends boolean = false>(options: Options<ActionsUpdateUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<ActionsUpdateUpdateResponse, unknown, ThrowOnError>({
        url: '/actions/updateUpdate/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const actionsDeleteUpdate = <ThrowOnError extends boolean = false>(options: Options<ActionsDeleteUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<unknown, unknown, ThrowOnError>({
        url: '/actions/deleteUpdate/{id}',
        ...options
    });
};

export const actionsAllUpdates = <ThrowOnError extends boolean = false>(options?: Options<ActionsAllUpdatesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ActionsAllUpdatesResponse, unknown, ThrowOnError>({
        url: '/actions/allUpdates',
        ...options
    });
};

export const actionsSuites = <ThrowOnError extends boolean = false>(options?: Options<ActionsSuitesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ActionsSuitesResponse, unknown, ThrowOnError>({
        url: '/actions/suites',
        ...options
    });
};

export const actionsSuite = <ThrowOnError extends boolean = false>(options: Options<ActionsSuiteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ActionsSuiteResponse, unknown, ThrowOnError>({
        url: '/actions/suite/{id}',
        ...options
    });
};

export const actionsCreateSuite = <ThrowOnError extends boolean = false>(options: Options<ActionsCreateSuiteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ActionsCreateSuiteResponse, unknown, ThrowOnError>({
        url: '/actions/createSuite',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const actionsBatchUpdateSuiteEvents = <ThrowOnError extends boolean = false>(options: Options<ActionsBatchUpdateSuiteEventsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<unknown, unknown, ThrowOnError>({
        url: '/actions/suite/{suiteId}/batchUpdateSuiteEvents/{eventId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const actionsAddSuiteEvent = <ThrowOnError extends boolean = false>(options: Options<ActionsAddSuiteEventData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ActionsAddSuiteEventResponse, unknown, ThrowOnError>({
        url: '/actions/suite/{suiteId}/events',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const actionsDeleteSuiteEvent = <ThrowOnError extends boolean = false>(options: Options<ActionsDeleteSuiteEventData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<ActionsDeleteSuiteEventResponse, unknown, ThrowOnError>({
        url: '/actions/suite/{suiteId}/events/{eventId}',
        ...options
    });
};

export const actionsTentativePlansForGroup = <ThrowOnError extends boolean = false>(options: Options<ActionsTentativePlansForGroupData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ActionsTentativePlansForGroupResponse, unknown, ThrowOnError>({
        url: '/actions/events/{eventId}/checkTentativePlans',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const actionsPreviewEmailHtml = <ThrowOnError extends boolean = false>(options: Options<ActionsPreviewEmailHtmlData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ActionsPreviewEmailHtmlResponse, unknown, ThrowOnError>({
        url: '/actions/previewEmailHtml/{eventId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const actionsPreviewTextMessage = <ThrowOnError extends boolean = false>(options: Options<ActionsPreviewTextMessageData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ActionsPreviewTextMessageResponse, unknown, ThrowOnError>({
        url: '/actions/previewTextMessage/{eventId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const actionsReloadAllActionUsersJoined = <ThrowOnError extends boolean = false>(options?: Options<ActionsReloadAllActionUsersJoinedData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/actions/reloadAllActionUsersJoined',
        ...options
    });
};

export const actionsReloadAllActionUsersCompleted = <ThrowOnError extends boolean = false>(options?: Options<ActionsReloadAllActionUsersCompletedData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/actions/reloadAllActionUsersCompleted',
        ...options
    });
};

export const actionsExportAction = <ThrowOnError extends boolean = false>(options: Options<ActionsExportActionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ActionsExportActionResponse, unknown, ThrowOnError>({
        url: '/actions/export/{id}',
        ...options
    });
};

export const actionsPasteJson = <ThrowOnError extends boolean = false>(options: Options<ActionsPasteJsonData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ActionsPasteJsonResponse, unknown, ThrowOnError>({
        url: '/actions/pasteJson',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const actionsReminderPlansOverview = <ThrowOnError extends boolean = false>(options?: Options<ActionsReminderPlansOverviewData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ActionsReminderPlansOverviewResponse, unknown, ThrowOnError>({
        url: '/actions/reminderPlansOverview',
        ...options
    });
};

export const actionsSuspendPlans = <ThrowOnError extends boolean = false>(options: Options<ActionsSuspendPlansData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ActionsSuspendPlansResponse, unknown, ThrowOnError>({
        url: '/actions/suspendPlans',
        ...options
    });
};

export const actionsGetShareLink = <ThrowOnError extends boolean = false>(options: Options<ActionsGetShareLinkData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ActionsGetShareLinkResponse, unknown, ThrowOnError>({
        url: '/actions/getShareLink/{id}',
        ...options
    });
};

export const actionsShareLinksForForm = <ThrowOnError extends boolean = false>(options: Options<ActionsShareLinksForFormData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ActionsShareLinksForFormResponse, unknown, ThrowOnError>({
        url: '/actions/shareLinksForForm/{formId}',
        ...options
    });
};

export const actionsShareUrlStats = <ThrowOnError extends boolean = false>(options: Options<ActionsShareUrlStatsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ActionsShareUrlStatsResponse, unknown, ThrowOnError>({
        url: '/actions/shareUrlStats/{actionId}',
        ...options
    });
};

export const actionsActionRelations = <ThrowOnError extends boolean = false>(options?: Options<ActionsActionRelationsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ActionsActionRelationsResponse, unknown, ThrowOnError>({
        url: '/actions/action-relations',
        ...options
    });
};

export const actionsActionRelationsForUser = <ThrowOnError extends boolean = false>(options: Options<ActionsActionRelationsForUserData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ActionsActionRelationsForUserResponse, unknown, ThrowOnError>({
        url: '/actions/action-relations/{userId}',
        ...options
    });
};

export const actionsGetCommunityMemberInfoAdmin = <ThrowOnError extends boolean = false>(options: Options<ActionsGetCommunityMemberInfoAdminData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ActionsGetCommunityMemberInfoAdminResponse, unknown, ThrowOnError>({
        url: '/actions/communityMemberInfo/{communityId}',
        ...options
    });
};

export const actionsGetCommunityMemberInfo = <ThrowOnError extends boolean = false>(options?: Options<ActionsGetCommunityMemberInfoData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ActionsGetCommunityMemberInfoResponse, unknown, ThrowOnError>({
        url: '/actions/communityMemberInfo',
        ...options
    });
};

export const notifsFindAll = <ThrowOnError extends boolean = false>(options?: Options<NotifsFindAllData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<NotifsFindAllResponse, unknown, ThrowOnError>({
        url: '/notifs',
        ...options
    });
};

export const notifsSetRead = <ThrowOnError extends boolean = false>(options: Options<NotifsSetReadData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
        url: '/notifs/read/{id}',
        ...options
    });
};

export const notifsSetReadAll = <ThrowOnError extends boolean = false>(options?: Options<NotifsSetReadAllData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
        url: '/notifs/read-all',
        ...options
    });
};

export const notifsNotifsForUser = <ThrowOnError extends boolean = false>(options: Options<NotifsNotifsForUserData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<NotifsNotifsForUserResponse, unknown, ThrowOnError>({
        url: '/notifs/for-user/{id}',
        ...options
    });
};

export const notifsLinkClick = <ThrowOnError extends boolean = false>(options: Options<NotifsLinkClickData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<NotifsLinkClickResponse, unknown, ThrowOnError>({
        url: '/notifs/linkClick',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Get all forum posts
 */
export const forumFindAllPosts = <ThrowOnError extends boolean = false>(options?: Options<ForumFindAllPostsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ForumFindAllPostsResponse, unknown, ThrowOnError>({
        url: '/forum/posts',
        ...options
    });
};

/**
 * Create a new forum post
 */
export const forumCreatePost = <ThrowOnError extends boolean = false>(options: Options<ForumCreatePostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ForumCreatePostResponse, unknown, ThrowOnError>({
        url: '/forum/posts',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Get posts for a specific action
 */
export const forumFindPostsByAction = <ThrowOnError extends boolean = false>(options: Options<ForumFindPostsByActionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ForumFindPostsByActionResponse, unknown, ThrowOnError>({
        url: '/forum/posts/action/{actionId}',
        ...options
    });
};

/**
 * Delete a post
 */
export const forumRemovePost = <ThrowOnError extends boolean = false>(options: Options<ForumRemovePostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<unknown, unknown, ThrowOnError>({
        url: '/forum/posts/{id}',
        ...options
    });
};

/**
 * Get a specific post with its comments
 */
export const forumFindOnePost = <ThrowOnError extends boolean = false>(options: Options<ForumFindOnePostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ForumFindOnePostResponse, unknown, ThrowOnError>({
        url: '/forum/posts/{id}',
        ...options
    });
};

/**
 * Update a post
 */
export const forumUpdatePost = <ThrowOnError extends boolean = false>(options: Options<ForumUpdatePostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<ForumUpdatePostResponse, unknown, ThrowOnError>({
        url: '/forum/posts/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Get all comments for a specific post
 */
export const forumFindCommentsForPost = <ThrowOnError extends boolean = false>(options: Options<ForumFindCommentsForPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ForumFindCommentsForPostResponse, unknown, ThrowOnError>({
        url: '/forum/posts/{id}/comments',
        ...options
    });
};

/**
 * Get all comments for a specific activity
 */
export const forumFindCommentsForActivity = <ThrowOnError extends boolean = false>(options: Options<ForumFindCommentsForActivityData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ForumFindCommentsForActivityResponse, unknown, ThrowOnError>({
        url: '/forum/activity/{id}/comments',
        ...options
    });
};

/**
 * Get all comments for a specific action
 */
export const forumFindCommentsForAction = <ThrowOnError extends boolean = false>(options: Options<ForumFindCommentsForActionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ForumFindCommentsForActionResponse, unknown, ThrowOnError>({
        url: '/forum/actions/{id}/comments',
        ...options
    });
};

/**
 * Get all posts by a specific user
 */
export const forumFindPostsByUser = <ThrowOnError extends boolean = false>(options: Options<ForumFindPostsByUserData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ForumFindPostsByUserResponse, unknown, ThrowOnError>({
        url: '/forum/posts/user/{id}',
        ...options
    });
};

/**
 * Get all comments by a specific user, excluding activity comments
 */
export const forumFindCommentsByUser = <ThrowOnError extends boolean = false>(options: Options<ForumFindCommentsByUserData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ForumFindCommentsByUserResponse, unknown, ThrowOnError>({
        url: '/forum/posts/user/{id}/comments',
        ...options
    });
};

/**
 * Get all forum comments by a specific user
 */
export const forumFindForumCommentsByUser = <ThrowOnError extends boolean = false>(options: Options<ForumFindForumCommentsByUserData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ForumFindForumCommentsByUserResponse, unknown, ThrowOnError>({
        url: '/forum/posts/user/{id}/forumComments',
        ...options
    });
};

/**
 * Create a new comment on a post
 */
export const forumCreateComment = <ThrowOnError extends boolean = false>(options: Options<ForumCreateCommentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ForumCreateCommentResponse, unknown, ThrowOnError>({
        url: '/forum/comments',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Delete a reply
 */
export const forumDeleteComment = <ThrowOnError extends boolean = false>(options: Options<ForumDeleteCommentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<unknown, unknown, ThrowOnError>({
        url: '/forum/comments/{id}',
        ...options
    });
};

/**
 * Update a comment
 */
export const forumUpdateComment = <ThrowOnError extends boolean = false>(options: Options<ForumUpdateCommentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<ForumUpdateCommentResponse, unknown, ThrowOnError>({
        url: '/forum/comments/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Like a comment
 */
export const forumLikeComment = <ThrowOnError extends boolean = false>(options: Options<ForumLikeCommentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ForumLikeCommentResponse, unknown, ThrowOnError>({
        url: '/forum/comments/{id}/like',
        ...options
    });
};

/**
 * Unlike a comment
 */
export const forumUnlikeComment = <ThrowOnError extends boolean = false>(options: Options<ForumUnlikeCommentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ForumUnlikeCommentResponse, unknown, ThrowOnError>({
        url: '/forum/comments/{id}/unlike',
        ...options
    });
};

/**
 * Like a comment
 */
export const forumLikePost = <ThrowOnError extends boolean = false>(options: Options<ForumLikePostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ForumLikePostResponse, unknown, ThrowOnError>({
        url: '/forum/posts/{id}/like',
        ...options
    });
};

/**
 * Unlike a post
 */
export const forumUnlikePost = <ThrowOnError extends boolean = false>(options: Options<ForumUnlikePostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ForumUnlikePostResponse, unknown, ThrowOnError>({
        url: '/forum/posts/{id}/unlike',
        ...options
    });
};

/**
 * Get all posts for admin management
 */
export const forumGetPostsForAdmin = <ThrowOnError extends boolean = false>(options?: Options<ForumGetPostsForAdminData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ForumGetPostsForAdminResponse, unknown, ThrowOnError>({
        url: '/forum/admin/posts',
        ...options
    });
};

/**
 * Update post experts and Q&A mode
 */
export const forumUpdatePostExperts = <ThrowOnError extends boolean = false>(options: Options<ForumUpdatePostExpertsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<ForumUpdatePostExpertsResponse, unknown, ThrowOnError>({
        url: '/forum/admin/posts/{id}/experts',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const geoSearchCity = <ThrowOnError extends boolean = false>(options: Options<GeoSearchCityData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GeoSearchCityResponse, unknown, ThrowOnError>({
        url: '/geo/search-city',
        ...options
    });
};

export const geoLoadCountryData = <ThrowOnError extends boolean = false>(options?: Options<GeoLoadCountryDataData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/geo/load-country-data',
        ...options
    });
};

export const geoLoadCityData = <ThrowOnError extends boolean = false>(options?: Options<GeoLoadCityDataData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/geo/ip',
        ...options
    });
};

export const paymentsCreatePaymentIntent = <ThrowOnError extends boolean = false>(options: Options<PaymentsCreatePaymentIntentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PaymentsCreatePaymentIntentResponse, unknown, ThrowOnError>({
        url: '/payments/create-payment-intent',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const paymentsSetPartialProfile = <ThrowOnError extends boolean = false>(options: Options<PaymentsSetPartialProfileData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
        url: '/payments/set-partial-profile',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const paymentsWebhook = <ThrowOnError extends boolean = false>(options?: Options<PaymentsWebhookData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
        url: '/payments/webhook',
        ...options
    });
};

export const paymentsPaymentMethod = <ThrowOnError extends boolean = false>(options?: Options<PaymentsPaymentMethodData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<PaymentsPaymentMethodResponse, unknown, ThrowOnError>({
        url: '/payments/payment-method',
        ...options
    });
};

export const paymentsClearPaymentMethods = <ThrowOnError extends boolean = false>(options?: Options<PaymentsClearPaymentMethodsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
        url: '/payments/clear-payment-method',
        ...options
    });
};

export const adminViewerGetTables = <ThrowOnError extends boolean = false>(options?: Options<AdminViewerGetTablesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AdminViewerGetTablesResponse, unknown, ThrowOnError>({
        url: '/admin-viewer/tables',
        ...options
    });
};

export const adminViewerGetTableData = <ThrowOnError extends boolean = false>(options: Options<AdminViewerGetTableDataData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<AdminViewerGetTableDataResponse, unknown, ThrowOnError>({
        url: '/admin-viewer/tables/{tableName}/data',
        ...options
    });
};

export const adminViewerDeleteRecords = <ThrowOnError extends boolean = false>(options: Options<AdminViewerDeleteRecordsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<AdminViewerDeleteRecordsResponse, unknown, ThrowOnError>({
        url: '/admin-viewer/tables/{tableName}/records',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const adminViewerCreateRecord = <ThrowOnError extends boolean = false>(options: Options<AdminViewerCreateRecordData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AdminViewerCreateRecordResponse, unknown, ThrowOnError>({
        url: '/admin-viewer/tables/{tableName}/records',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const adminViewerUpdateRecord = <ThrowOnError extends boolean = false>(options: Options<AdminViewerUpdateRecordData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<AdminViewerUpdateRecordResponse, unknown, ThrowOnError>({
        url: '/admin-viewer/tables/{tableName}/records',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const searchAll = <ThrowOnError extends boolean = false>(options: Options<SearchAllData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<SearchAllResponse, unknown, ThrowOnError>({
        url: '/search/all',
        ...options
    });
};

export const searchSaveSelected = <ThrowOnError extends boolean = false>(options: Options<SearchSaveSelectedData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
        url: '/search/selected',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const tasksSubmitForm = <ThrowOnError extends boolean = false>(options: Options<TasksSubmitFormData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<TasksSubmitFormResponse, unknown, ThrowOnError>({
        url: '/tasks/submitForm/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const tasksSubmitPublicForm = <ThrowOnError extends boolean = false>(options: Options<TasksSubmitPublicFormData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<TasksSubmitPublicFormResponse, unknown, ThrowOnError>({
        url: '/tasks/submitPublicForm/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const tasksCreateForm = <ThrowOnError extends boolean = false>(options: Options<TasksCreateFormData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<TasksCreateFormResponse, unknown, ThrowOnError>({
        url: '/tasks/createForm',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const tasksListForms = <ThrowOnError extends boolean = false>(options?: Options<TasksListFormsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<TasksListFormsResponse, unknown, ThrowOnError>({
        url: '/tasks/listForms',
        ...options
    });
};

export const tasksGetFormResponses = <ThrowOnError extends boolean = false>(options: Options<TasksGetFormResponsesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<TasksGetFormResponsesResponse, unknown, ThrowOnError>({
        url: '/tasks/responses/{id}',
        ...options
    });
};

export const tasksGetMyFormResponse = <ThrowOnError extends boolean = false>(options: Options<TasksGetMyFormResponseData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<TasksGetMyFormResponseResponse, unknown, ThrowOnError>({
        url: '/tasks/myResponse/{id}',
        ...options
    });
};

export const tasksGetForm = <ThrowOnError extends boolean = false>(options: Options<TasksGetFormData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<TasksGetFormResponse, unknown, ThrowOnError>({
        url: '/tasks/slug/{id}',
        ...options
    });
};

export const tasksUpdateForm = <ThrowOnError extends boolean = false>(options: Options<TasksUpdateFormData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<TasksUpdateFormResponse, unknown, ThrowOnError>({
        url: '/tasks/updateForm/{formId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const tasksDeleteForm = <ThrowOnError extends boolean = false>(options: Options<TasksDeleteFormData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<unknown, unknown, ThrowOnError>({
        url: '/tasks/{id}',
        ...options
    });
};

export const tasksCustomValidators = <ThrowOnError extends boolean = false>(options?: Options<TasksCustomValidatorsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<TasksCustomValidatorsResponse, unknown, ThrowOnError>({
        url: '/tasks/customValidators',
        ...options
    });
};

export const tasksRunValidator = <ThrowOnError extends boolean = false>(options: Options<TasksRunValidatorData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<TasksRunValidatorResponse, unknown, ThrowOnError>({
        url: '/tasks/runValidator/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const tasksFindOneCustomValidator = <ThrowOnError extends boolean = false>(options: Options<TasksFindOneCustomValidatorData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<TasksFindOneCustomValidatorResponse, unknown, ThrowOnError>({
        url: '/tasks/findOneCustomValidator/{id}',
        ...options
    });
};

export const tasksCreateCustomValidator = <ThrowOnError extends boolean = false>(options: Options<TasksCreateCustomValidatorData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<TasksCreateCustomValidatorResponse, unknown, ThrowOnError>({
        url: '/tasks/createCustomValidator',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const tasksOptout = <ThrowOnError extends boolean = false>(options: Options<TasksOptoutData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<TasksOptoutResponse, unknown, ThrowOnError>({
        url: '/tasks/optout/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const tasksGetFormsForUserSid = <ThrowOnError extends boolean = false>(options: Options<TasksGetFormsForUserSidData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<TasksGetFormsForUserSidResponse, unknown, ThrowOnError>({
        url: '/tasks/formsForUserSID/{userId}',
        ...options
    });
};

export const analyticsGetTimeSpentPerUser = <ThrowOnError extends boolean = false>(options?: Options<AnalyticsGetTimeSpentPerUserData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AnalyticsGetTimeSpentPerUserResponse, unknown, ThrowOnError>({
        url: '/analytics/time-spent-per-user',
        ...options
    });
};

export const analyticsGetTimeSpentPerUserTotal = <ThrowOnError extends boolean = false>(options?: Options<AnalyticsGetTimeSpentPerUserTotalData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AnalyticsGetTimeSpentPerUserTotalResponse, unknown, ThrowOnError>({
        url: '/analytics/time-spent-per-user-total',
        ...options
    });
};

export const analyticsGetDailyStats = <ThrowOnError extends boolean = false>(options: Options<AnalyticsGetDailyStatsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<AnalyticsGetDailyStatsResponse, unknown, ThrowOnError>({
        url: '/analytics/daily-stats',
        ...options
    });
};

export const analyticsGetActionStats = <ThrowOnError extends boolean = false>(options?: Options<AnalyticsGetActionStatsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AnalyticsGetActionStatsResponse, unknown, ThrowOnError>({
        url: '/analytics/action-stats',
        ...options
    });
};

export const analyticsRecalculateActionStats = <ThrowOnError extends boolean = false>(options?: Options<AnalyticsRecalculateActionStatsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<AnalyticsRecalculateActionStatsResponse, unknown, ThrowOnError>({
        url: '/analytics/action-stats/recalculate',
        ...options
    });
};

export const analyticsGetMemberCompletionRetention = <ThrowOnError extends boolean = false>(options?: Options<AnalyticsGetMemberCompletionRetentionData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AnalyticsGetMemberCompletionRetentionResponse, unknown, ThrowOnError>({
        url: '/analytics/member-completion-retention',
        ...options
    });
};

export const analyticsGetTimeToChurnSamples = <ThrowOnError extends boolean = false>(options?: Options<AnalyticsGetTimeToChurnSamplesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AnalyticsGetTimeToChurnSamplesResponse, unknown, ThrowOnError>({
        url: '/analytics/time-to-churn',
        ...options
    });
};

export const analyticsGetAggregateStats = <ThrowOnError extends boolean = false>(options?: Options<AnalyticsGetAggregateStatsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AnalyticsGetAggregateStatsResponse, unknown, ThrowOnError>({
        url: '/analytics/aggregate-stats',
        ...options
    });
};

export const analyticsGetContractStatusHistory = <ThrowOnError extends boolean = false>(options: Options<AnalyticsGetContractStatusHistoryData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<AnalyticsGetContractStatusHistoryResponse, unknown, ThrowOnError>({
        url: '/analytics/contract-status-history',
        ...options
    });
};